
  import {Component, Model, Prop, Vue, Watch} from "vue-property-decorator";
  import {PaymentCategoryDto, PaymentCategoryScope} from "@/api/appService";
  import api from '@/api/index'
  import {createNgTree, createSelectTree} from "@/utils/tree";
  import {paymentCategoryScopeMapping} from "@/core/constants";

  interface CategoryItem{
    data:PaymentCategoryDto,
    disabled:boolean
  }

  @Component({
    name:'PaymentCategorySelect',
    filters:{
      filterScope(value:PaymentCategoryScope){
        let result = paymentCategoryScopeMapping[value];
        return result?result:value;
      }
    }
  })
  export default class PaymentCategorySelect extends Vue{

    @Model('change')categoryId?:number;

    @Prop({required:false,default:true})
    clearable!:boolean;

    @Prop({required:false,default:'请选择类别'})
    placeholder!:string;

    @Prop({required:false})
    filterScope?:PaymentCategoryScope;

    @Prop({required:false})
    filterScopes?:PaymentCategoryScope[];

    private currentValue?:number = -1;

    private selectTree:PaymentCategoryDto[] = [];




    created(){
      this.loadCategories();
    }

    loadCategories(){
      api.paymentCategoryService.getAll({maxResultCount:65545,sorting:'id asc'}).then(res=>{
        let categories = res.items!.filter(category=>!this.isDisabled(category));

        this.selectTree = createSelectTree(categories,
                'parentId',
                'id',
                null,
                'displayName');
      });
      setTimeout(()=>{
        if(this.categoryId ){
          this.currentValue = this.categoryId;
        } else {
          this.currentValue = undefined;
        }
      },100);
    }

    isDisabled(item:PaymentCategoryDto){

      if(this.filterScope){
        return this.filterScope !== item.scope;
      } else if(this.filterScopes && this.filterScopes.length){
        return !this.filterScopes!.some(scope=>scope === item.scope);
      }

      return false;
    }

    @Watch('categoryId')
    onCategoryIdChange(newValue?:number){
      if(newValue === 0){
        this.currentValue = undefined;
      } else {
        this.currentValue = newValue;
      }

    }




    handleValueChange(newValue?:number){
      let that = this;
      this.$emit('change',newValue);
    }

  }
